import { render, staticRenderFns } from "./HardwareSetup.vue?vue&type=template&id=05f4a453&scoped=true&"
import script from "./HardwareSetup.vue?vue&type=script&lang=js&"
export * from "./HardwareSetup.vue?vue&type=script&lang=js&"
import style0 from "./HardwareSetup.vue?vue&type=style&index=0&id=05f4a453&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4a453",
  null
  
)

export default component.exports